import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BASE_SITE_URL,
  getSeoForPathname,
  normalizePathname,
} from './routeSeoConfig';

const ensureMetaTag = (attribute, value) => {
  let tag = document.head.querySelector(`meta[${attribute}="${value}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, value);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureLinkTag = (relValue) => {
  let tag = document.head.querySelector(`link[rel="${relValue}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', relValue);
    document.head.appendChild(tag);
  }
  return tag;
};

const toCanonicalUrl = (pathname) => {
  const normalized = normalizePathname(pathname);
  if (normalized === '/') return `${BASE_SITE_URL}/`;
  return `${BASE_SITE_URL}${normalized}`;
};

const setNamedMeta = (name, content) => {
  const tag = ensureMetaTag('name', name);
  tag.setAttribute('content', content);
};

const setPropertyMeta = (property, content) => {
  const tag = ensureMetaTag('property', property);
  tag.setAttribute('content', content);
};

const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeoForPathname(pathname);
    const canonicalUrl = toCanonicalUrl(seo.canonicalPath || pathname);

    document.title = seo.title;
    setNamedMeta('description', seo.description);
    setNamedMeta('robots', seo.robots);
    setPropertyMeta('og:title', seo.title);
    setPropertyMeta('og:description', seo.description);
    setPropertyMeta('og:url', canonicalUrl);
    setNamedMeta('twitter:title', seo.title);
    setNamedMeta('twitter:description', seo.description);

    const canonicalTag = ensureLinkTag('canonical');
    canonicalTag.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
};

export default RouteSeo;
